import React, { CSSProperties, useState } from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  InputRightElement,
} from '@chakra-ui/react';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { Eye, EyeSlash } from 'phosphor-react';

interface PasswordInputFormProps extends InputProps {
  name: string | undefined | any;
  label: string | undefined;
  iconLeft?: JSX.Element;
  labelStyles?: CSSProperties;
  buttonStyles?: CSSProperties;
  isRequired?: boolean;
  register: UseFormRegister<FieldValues>;
  errors: any;
}

export const PasswordInputForm = ({
  name,
  label,
  iconLeft,
  labelStyles,
  buttonStyles,
  isRequired = false,
  register,
  errors,
  ...rest
}: PasswordInputFormProps) => {
  const [show, setShow] = useState(false);

  const handleClick = () => setShow((current) => !current);
  return (
    <FormControl isRequired={isRequired} isInvalid={!!errors[name]} mb={2}>
      <FormLabel style={labelStyles} fontWeight="bold" mb={1} htmlFor={name}>
        {label}
      </FormLabel>
      <InputGroup alignItems="center" alignContent="center">
        {iconLeft && (
          <InputLeftElement pointerEvents="none" fontSize="1.2em">
            {iconLeft}
          </InputLeftElement>
        )}
        <Input
          id={name}
          type={show ? 'text' : 'password'}
          boxShadow="0px 3px 6px #00000065"
          background="theme.light.bodyInput"
          {...register(name)}
          {...rest}
        />
        <InputRightElement fontSize="1.2em">
          <IconButton
            zIndex={1}
            type="button"
            aria-label={show ? 'Ocultar senha' : 'Mostrar senha'}
            data-testid={`password-toggle-${name}`}
            style={buttonStyles}
            _focus={{ outline: 'none' }}
            variant="outline"
            border="none"
            colorScheme="none"
            onClick={handleClick}
          >
            {show ? <Eye size={20} /> : <EyeSlash size={20} />}
          </IconButton>
        </InputRightElement>
      </InputGroup>
      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
